import { Util } from '@libs/utilities/util';

import { EnumGroup, IProcessingOptions } from '../kw-workbench.interface';


export class GroupPipeHelper {


	processGrouping(keywords: string[], options: IProcessingOptions): string[][] {

		//0 - is the formatting option valid?
		if (!Util.Enum.isValid(EnumGroup, options.group)) throw new Error(`GroupPipeHelper => processGrouping => FATAL ERROR: the groupOptions of "${options.group}" is invalid (valid are: "${Util.Enum.values(EnumGroup).join(', ')}")`);
		const wordSplitChar: string = (options.actions.combineWordsBy.active && !Util.String.isEmpty(options.actions.combineWordsBy.combineBy))
			? options.actions.combineWordsBy.combineBy
			: ' ';

		//1 - format the text of the keywords
		switch (options.group) {
			case EnumGroup.NoGrouping:
				return [keywords];

			case EnumGroup.SingleAndPhrase:
				const groupedSingleAndPhrase: Array<string[]> = Util.ArrayGroup.group(keywords, (a: string, b: string) => {
					return (a.split(wordSplitChar).length === 1 && b.split(wordSplitChar).length === 1)
						|| (a.split(wordSplitChar).length > 1 && b.split(wordSplitChar).length > 1);
				});
				return this.sortSingleThenPhrase(groupedSingleAndPhrase);

			case EnumGroup.WordCount:
				const groupedWordCount: Array<string[]> = Util.ArrayGroup.group(keywords, (a: string, b: string) => a.split(wordSplitChar).length === b.split(wordSplitChar).length);
				return this.sortSingleThenPhrase(groupedWordCount);

			default:
				throw new Error(`GroupPipeHelper => processGrouping => FATAL ERROR: grouping behavior of "${options.group}" is not defined`);
		}
	}


	/**------------------------------------------------------
	 * Helper Functions
	 */
	private sortSingleThenPhrase(groupedKeywords: Array<string[]>): Array<string[]> {

		// make sure the single are first
		return groupedKeywords.sort((aArray: string[], bArray: string[]) => {
			const aAvg: number = aArray.reduce((a: number, b: string, i: number, arr: string[]) => a + Util.Text.wordSplit(b).length / arr.length, 0);
			const bAvg: number = bArray.reduce((a: number, b: string, i: number, arr: string[]) => a + Util.Text.wordSplit(b).length / arr.length, 0);
			return aAvg - bAvg;
		});
	}
}
